export default "__VITE_PUBLIC_ASSET__08c7cc0c__"